import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SignUp from "./SignUp";
import VerifyEmail from "../VerifyEmail";
import Modal from "../Modal";
import { StorageService } from "@services/StorageService";
import { useService } from "@/base/hooks/useService";

import styles from "./index.module.scss";
import { localstorageKeys } from "@const/store";
import { signUpReset } from "@redux/signUp/actions";
import { verificationReset } from "@redux/verification/actions";
import { signIn } from "@redux/signIn/actions";

const SignUpModal = () => {
  const [signUpStep, setSignUpStep] = useState(true);
  const [dataSent, setDataSent] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const storageService = useService(StorageService);
  const dispatch = useDispatch();

  const { isSuccess, isModalVisible } = useSelector(
    ({ signUpReducer }) => signUpReducer,
  );

  const closeModal = () => {
    dispatch(signUpReset());
    dispatch(verificationReset());
    // setTimeout is used to prevent flickering
    setTimeout(() => {
      setSignUpStep(true);
      setEmail("");
      setPassword("");
      setDataSent(false);
    }, 500);
  };

  useEffect(() => {
    if (!isSuccess) return;

    setSignUpStep(false);
    setDataSent(true);

    storageService.set(localstorageKeys.sentAt, Date.now());
  }, [isSuccess]);

  const successCallback = () => {
    if (!email || !password) return;
    closeModal();
    dispatch(signIn({ email, password }));
  };

  const onBackClick = () => {
    setSignUpStep(true);
  };

  return (
    <Modal
      centered
      unmountOnClose
      showCancel={false}
      showConfirm={false}
      onClose={closeModal}
      isOpen={isModalVisible}
      footerClassName="d-none"
      className="sign-up-modal"
      bodyClassName={styles.body}
    >
      <SignUp
        dataSent={dataSent}
        setEmail={setEmail}
        isVisible={signUpStep}
        setPassword={setPassword}
        setSignUpStep={setSignUpStep}
      />
      <VerifyEmail
        email={email}
        isVisible={!signUpStep}
        onBackClick={onBackClick}
        successCallback={successCallback}
      />
    </Modal>
  );
};

export default SignUpModal;
